import React from 'react';
import { FormattedMessage } from 'react-intl';

import { trackEvent } from '@xingternal/hops-tracking';
import { StarRating } from '@xingternal/star-rating';

import { KununuLink, KununuLogo, KununuReviews } from '@/components/kununu';
import { KununuData } from '@/domain/job-details/components/company-module/employer-actions/employer-types';

import * as S from './kununu-rating.styles';

type Props = {
  kununuData: KununuData;
};

export const KununuRating: React.FC<Props> = ({ kununuData }) => {
  const { companyProfileUrl, ratingAverage } = kununuData;
  const ratingCount = kununuData.ratingCount ?? 0;

  const onKununuLinkClick = (): void =>
    trackEvent('PropTrackAction', { PropTrackAction: 'jobs_company_module_kununu_logo_click' });

  return (
    <>
      <S.StyledTitle>
        <S.RatingHeadline size="large" sizeWide="xlarge">
          <FormattedMessage id="JOBS_DETAIL_EMPLOYEE_REVIEWS_TITLE" />
        </S.RatingHeadline>
        <KununuLogo />
      </S.StyledTitle>
      <KununuLink companyProfileUrl={companyProfileUrl} onClick={onKununuLinkClick}>
        <div>
          <StarRating rating={ratingAverage ?? 0} />
          <KununuReviews ratingCount={ratingCount} />
        </div>
      </KununuLink>
    </>
  );
};
